import { getGTMEventData } from '@tracking/components/transformer';
import { getDestinationUrl } from '@tracking/components/utils';

function eventFormatter({
  element, link,
  text, tagName,
  action, eventType,
  category, ...rest
}) {
  const textContent = text ? text.substring(0, 999) : undefined;
  const data = {
    element, text: textContent, ...rest,
  };
  const destinationUrlData = getDestinationUrl(link);
  const eventName = `${tagName}_${eventType}`;
  return getGTMEventData(
    eventName,
    action || eventName,
    { ...data, ...destinationUrlData },
    element,
    undefined,
    category,
  );
}

export default eventFormatter;
